/* eslint-disable no-irregular-whitespace */
import { IAgency, IMedal } from '../../../common/types/rating';

import { generateTitle } from './utils/generateTitle';

export const findMedal = (agency: IAgency, visible: boolean): IMedal | undefined => {
  if (!visible) {
    return;
  }
  const posArray = [
    {
      pos: agency.posArea,
      label: 'Мастер квадратных метров',
    },
    {
      pos: agency.posShowsSale,
      label: 'Лидер по охвату в продаже недвижимости',
    },
    {
      pos: agency.posShowsRent,
      label: 'Лидер по охвату в аренде недвижимости',
    },
    {
      pos: agency.posRealAmountAuction,
      label: 'Мастер аукциона',
    },
    {
      pos: agency.posCntTop,
      label: 'Мастер ТОП',
    },
    {
      pos: agency.posCntPremium,
      label: 'Мастер Премиум',
    },
  ];

  return posArray.find(item => item.pos === 1);
};

export const generateDataForLinks = (agency: IAgency) => {
  const { posShows, dateRating, nameGroup, urlLogo } = agency;

  const urlForSocial = window.location.href;

  const title = generateTitle(posShows, dateRating, nameGroup);

  const tgAndVk = title + '&utm_source=share2';

  return [
    {
      name: 'tg',
      url: `https://t.me/share/url?url=${urlForSocial}&text=${tgAndVk}`,
    },
    {
      name: 'vk',
      url: `https://vk.com/share.php?url=${urlForSocial}&title=${tgAndVk}`,
    },
    {
      name: 'wh',
      url: `https://api.whatsapp.com/send?text=${title}. Циан представляет ежемесячный рейтинг профессионалов на рынке недвижимости &nbsp;${urlForSocial}&utm_source=share2`,
    },
    {
      name: 'ok',
      url: `https://connect.ok.ru/offer?url=${urlForSocial}&title=${title}&imageUrl=${urlLogo}&utm_source=share2`,
    },
  ];
};
